module.exports = (() => {
    let _elements = {};
    let _data = {};

    /**
     * @param element
     * @private
     */
    let _cacheDom = (element) => {
        _elements.$filterInput = element.find('.stores__filter-input');
        _elements.$filterClear = element.find('.stores__filter-clear');
        _elements.$noMatch = element.find('.stores__no-match');
        _elements.$storesLists = element.find('.column-list');
        _elements.$stores = element.find('.column-list__item__title');
    };

    /**
     * Caches all store titles and views in a structure for easy filtering.
     *
     * @private
     */
    let _cacheData = () => {
        _data.storeLists = _elements.$storesLists.map((i, list) => {
            let $container = $(list);

            let stores = $container.find('.column-list__item__title').map((j, store) => {
                let $storeView = $(store);
                return {
                    title: $storeView.data('title'),
                    $view: $storeView
                }
            });

            return {
                title: $container.data('title'),
                $view: $container,
                stores: stores
            }
        });
    };

    /**
     * @private
     */
    let _bindEvents = () => {
        _elements.$filterInput.on('keyup', () => {
            const text = _elements.$filterInput.val().toLowerCase();

            text.length > 0 ? _elements.$filterClear.fadeIn('fast')
                            : _elements.$filterClear.fadeOut('fast');

            _filterStores(text);
        });

        _elements.$filterClear.on('click', _clearFilter);
    };

    /**
     * Shows/hides stores depending on if their titles start with given text. If no store title in list starts with
     * given text then the whole list is hidden.
     *
     * @param text
     * @private
     */
    let _filterStores = text => {

        let listsShownCount = 0;

        for (let i = 0; i < _data.storeLists.length; i++) {

            let listMatch = false;

            // Check if any store in the list matches text, show does who does, hide does who doesnt
            _data.storeLists[i].stores.each((j, store) => {
                let storeMatch = store.title.startsWith(text);
                storeMatch ? store.$view.show() : store.$view.hide();
                if (storeMatch) {
                    listMatch = true;
                }
            })

            // Only show list if any of its children matches text. Also keep track of how many lists are shown for user
            // feedback if all lists are hidden.
            if (listMatch) {
                _data.storeLists[i].$view.show();
                listsShownCount++;
            }
            else {
                // Hide list if none of the children matches text
                _data.storeLists[i].$view.hide();
            }
        }

        // Show "no matches" message if all lists is hidden (eg. no matches at all)
        listsShownCount === 0 ? _elements.$noMatch.show() : _elements.$noMatch.hide();
    };

    /**
     * Clears input field. Shows all stores and store lists.
     * @private
     */
    let _clearFilter = () => {
        _elements.$filterInput.val('');
        _elements.$stores.show();
        _elements.$storesLists.show();
        _elements.$noMatch.hide();
        _elements.$filterClear.fadeOut('fast');
    };

    return {
        init: () => {
            let element = $('.stores');

            if (!element) {
                return false;
            }

            _cacheDom(element);
            _cacheData();
            _bindEvents();
        }
    }
})();
